// UTM helper for the Danone landing page.
const UTM_PARAMS: Record<string, string> = {
  utm_source: "orange-business",
  utm_medium: "wl",
  utm_campaign: "orange-business-wl",
};

export const withUtm = (href: string): string => {
  if (!href) return href;
  if (!/^https?:\/\//i.test(href)) return href;
  try {
    const url = new URL(href);
    Object.entries(UTM_PARAMS).forEach(([k, v]) => {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, v);
      }
    });
    return url.toString();
  } catch {
    return href;
  }
};
